module.exports = __webpack_public_path__ + "img/olimpiya.7ac759f9.png";